var moverDetail = function(){
  var _init = function(){

    setTimeout(function(){
      document.body.classList.add('is-mover-init');
    }, 100);
  };

  return{
    init: _init
  }
}();

if (document.getElementById('mover-detail')) {
  document.addEventListener('DOMContentLoaded', moverDetail.init);
}